// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__MNbfw","actions":"GroupTable_actions__1Phtn","deleteModalFooter":"GroupTable_deleteModalFooter__1GRLL"};